import { MLSListing } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { NoData } from '../NoData.tsx';
import { MLSDataHeader } from '../Tkv2MlsDataHeader/MLSDataHeader.tsx';
import { ReferenceViewID } from '../index.ts';
import { MLSAgentDetails } from './MLSAgentDetails.tsx';
import { MLSAttributionInfo } from './MLSAttributionInfo.tsx';
import { MLSDataImages } from './MLSDataImages.tsx';
import { MLSFeatures } from './MLSFeatures.tsx';
import { MLSHoaInfo } from './MLSHoaInfo.tsx';
import { MLSListingInformation } from './MLSListingInformation.tsx';
import { MLSLocationInfo } from './MLSLocationInfo.tsx';
import { MLSMajorStatistics } from './MLSMajorStatistics.tsx';
import { MLSPropertyDetails } from './MLSPropertyDetails.tsx';
import { MLSPublicRemarks } from './MLSPublicRemarks.tsx';
import { MLSSchoolInfo } from './MLSSchoolInfo.tsx';
import { MLSSiteInfo } from './MLSSiteInfo.tsx';
import { MLSTaxInfo } from './MLSTaxInfo.tsx';
import { useMlsDataSheetParams } from './hooks/useMlsDataSheetParams.ts';

export const Tkv2MlsDataSheet = ({
  referenceViewID,
  isPopout,
  listingData,
}: {
  referenceViewID: ReferenceViewID;
  isPopout: boolean;
  listingData: MLSListing;
}) => {
  const mlsDataSheetParams = useMlsDataSheetParams();
  if (Object.keys(listingData).length === 0) {
    return (
      <NoData
        text="No listing information available"
        referenceViewID={referenceViewID}
        updateMLSInfo
      />
    );
  }

  return (
    <Flex flexDirection="column" maxWidth="50rem" marginLeft="1rem" marginRight="1rem">
      <MLSDataHeader
        listingData={listingData}
        referenceViewID={referenceViewID}
        isPopout={isPopout}
        headerType="data"
        mlsDataSheetParams={mlsDataSheetParams}
      />
      <MLSDataImages media={listingData.Media} />
      <MLSMajorStatistics listingData={listingData} />
      <MLSPublicRemarks listingData={listingData} />
      <MLSListingInformation listingData={listingData} />
      <MLSPropertyDetails listingData={listingData} />
      <MLSTaxInfo listingData={listingData} />
      <MLSSiteInfo listingData={listingData} />
      <MLSFeatures listingData={listingData} />
      <MLSHoaInfo listingData={listingData} />
      <MLSLocationInfo listingData={listingData} />
      <MLSSchoolInfo listingData={listingData} />
      <MLSAgentDetails listingData={listingData} />
      <MLSAttributionInfo listingData={listingData} />
    </Flex>
  );
};
